import styled from "styled-components";
import Link from "next/link";

import { FormatDate } from "utils/formatters";

interface Props {
  event: any;
}

const EventCard = ({ event }: Props) => {
  return (
    <Link href={`/etkinlik/${event.slug}`} passHref>
      <Container>
        <ImageContainer>
          <PriceLabel>{event.price}</PriceLabel>
          <Image src={event.image} alt={event.title} width={350} height={350} />
        </ImageContainer>
        <MainContainer>
          <InnerContainer>
            <DateContainer>
              <DateMonth>
                {new Date(event.startDate)
                  .toLocaleString("tr-TR", {
                    month: "short",
                  })
                  .toLocaleUpperCase("tr-TR")}
              </DateMonth>
              <DateDay>{new Date(event.startDate).getDate()}</DateDay>
            </DateContainer>
            <ContentContainer>
              <ContentTitle>{event.title}</ContentTitle>
              <ContentDescription>{event.description}</ContentDescription>
            </ContentContainer>
          </InnerContainer>
          <OwnerContainer>
            <OwnerLabel>Düzenleyen: </OwnerLabel>
            <Link href={event.ownerProfileUrl} passHref>
              <a target="_blank" rel="noopener" aria-label="instagram">
                <OwnerTitle>{event.ownerName}</OwnerTitle>
              </a>
            </Link>
          </OwnerContainer>
        </MainContainer>
      </Container>
    </Link>
  );
};

export default EventCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 10px 0px;
  cursor: pointer;
`;

const ImageContainer = styled.div`
  position: relative;
`;

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  height: 300px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const PriceLabel = styled.div`
  background-color: white;
  position: absolute;
  left: 15px;
  bottom: 15px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 4px;
  padding: 7px 10px;
  box-shadow: 0px 6px 9px rgba(0, 0, 0, 0.07),
    0px 0.751293px 1.12694px rgba(0, 0, 0, 0.035);
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0px 6px 9px rgba(0, 0, 0, 0.07),
    0px 0.751293px 1.12694px rgba(0, 0, 0, 0.035);
  padding: 24px 12px;
`;

const InnerContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
  margin-top: 2px;
`;

const DateDay = styled.span`
  font-size: 16px;
  color: #0e202f;
  font-weight: 700;
`;
const DateMonth = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.main.primary};
  font-weight: 700;
  margin-bottom: 6px;
`;

const ContentContainer = styled.div``;

const ContentTitle = styled.h5`
  font-size: 16px;
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  color: #0e202f;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
const ContentDescription = styled.span`
  color: #67686a;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

const OwnerContainer = styled.div`
  margin-top: 20px;
  // display: flex;
  // justify-content: space-between;
`;
const OwnerLabel = styled.span`
  font-size: 14px;
  color: #0e202f;
  font-weight: 700;
`;
const OwnerTitle = styled.span`
  color: ${(props) => props.theme.main.primary};
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  margin-left: 5px;
`;
